import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

/**
 * Update the value and the validity of a FormGroup or a FormArray and all it's descendants
 * @param form FormGroup or FormArray to update validity
 * @param opts Same options as for standard Angular forms updateValueAndValidity
 */
export function updateValueAndValidity(
    form: UntypedFormGroup | UntypedFormArray,
    opts?: {
        onlySelf?: boolean,
        emitEvent?: boolean
    }): void {
    if (!form) {
        return;
    }

    Object.keys(form.controls || {}).forEach((controlName: string) => {
        const childControl = form.get(controlName);
        if (!childControl) {
            return;
        }

        if (childControl instanceof UntypedFormGroup || childControl instanceof UntypedFormArray) {
            childControl.markAsTouched({onlySelf: true});
            updateValueAndValidity(childControl, opts);
        } else {
            childControl.markAsTouched({onlySelf: true});
            childControl.updateValueAndValidity(opts);
        }
    });
}
